export enum ConnectionStatus {
  CONNECTED = 'connected',
  FAILED = 'failed',
  RETRYING = 'retrying',
  NOT_STARTED = 'not-started',
}

export enum BroadcastEventType {
  MESSAGE = 'message',
  CONNECTION_STATUS = 'connection_status',
  REQUEST_STATE = 'request_state',
  LEADER_IS_ALIVE = 'leader_is_alive',
}
